import {KTCard} from '../../../_metronic/helpers'
import {ListHeader} from './components/header/ListHeader'

import {PostCategoryTable} from './PostCategoryTable'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {ListViewProvider, useListView} from './core/ListViewProvider'
import {PostCategoryEditModal} from './post-category-add-edit/PostCategoryEditModal'

const PostCategoryList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <ListHeader />
        <PostCategoryTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <PostCategoryEditModal />}
    </>
  )
}

const PostCategoryListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <PostCategoryList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {PostCategoryListWrapper}
